import React, { useState } from "react";
import "../assets/css/FloatingEnquiry.css";

export default function FloatingEnquiry() {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* Floating Button */}
            <button
                className="am-enquiry-float-btn"
                onClick={() => setOpen(true)}
            >
                Enquire Now
            </button>

            {/* Modal */}
            {open && (
                <div className="am-enquiry-overlay" onClick={() => setOpen(false)}>
                    <div
                        className="am-enquiry-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="am-enquiry-close"
                            onClick={() => setOpen(false)}
                        >
                            ×
                        </button>

                        <h2 className="am-enquiry-title">Admission Enquiry</h2>
                        <p className="am-enquiry-subtitle">
                            Fill the details and our counsellor will connect with you.
                        </p>

                        <form className="am-enquiry-form">
                            <input
                                type="text"
                                placeholder="Student Name"
                                required
                            />

                            <input
                                type="tel"
                                placeholder="Mobile Number"
                                required
                            />

                            <select required>
                                <option value="">Select Class</option>
                                <option>8th</option>
                                <option>9th</option>
                                <option>10th</option>
                            </select>

                            <select required>
                                <option value="">Select Board</option>
                                <option>SSC</option>
                                <option>CBSE</option>

                            </select>

                            <button type="submit" className="am-enquiry-submit">
                                Submit Enquiry
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
